// src/screens/admin/mentors/Mentors.js
import React, { useContext, useEffect, useState } from "react";
import { Form, Button, Table, Badge } from "react-bootstrap";
import AdminLayout from "../../../layouts/admin/adminlayout/AdminLayout";
import "../../../assets/css/admin/mentors/Mentors.css";
import axios from "axios";
import AppContext from "../../../context/AppContext";

const Mentors = () => {
  const { baseUrl } = useContext(AppContext);
  // Form State
  const [mentorId, setMentorId] = useState();
  const [name, setName] = useState();
  const [degree, setDegree] = useState();
  const [specialization, setSpecialization] = useState();
  const [subject, setSubject] = useState();
  const [mentors, setMentors] = useState([]);
  const [isCreateUpdateLoading, setIsCreateUpdateLoading] = useState(false);

  // Edit State
  const [editId, setEditId] = useState(null);

  //create
  const createMentor = () => {
    const formData = new FormData();
    formData.append("name", name);
    formData.append("degree", degree);
    formData.append("specialization", specialization);
    formData.append("subject", subject);

    axios
      .post(`${baseUrl}/admin/mentor/createMentor`, formData, {
        headers: {
          "Content-Type": "multipart-formdata",
        },
      })
      .then((response) => {
        console.log(response.data);
        viewAllMentor();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //viewAll
  const viewAllMentor = () => {
    axios
      .post(`${baseUrl}/admin/mentor/viewAllMentor`)
      .then((response) => {
        console.log(response.data);
        setMentors(response.data.mentor);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //update
  const updateMentor = () => {
    const formData = new FormData();
    formData.append("id", mentorId);
    formData.append("name", name);
    formData.append("degree", degree);
    formData.append("specialization", specialization);
    formData.append("subject", subject);

    axios
      .post(`${baseUrl}/admin/mentor/updateMentor`, formData, {
        headers: {
          "Content-Type": "multipart-formdata",
        },
      })
      .then((response) => {
        console.log(response.data);
        viewAllMentor();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //delete
  const deleteMentor = (mentor_id) => {
    const formData = new FormData();
    formData.append("id", mentor_id);

    axios
      .post(`${baseUrl}/admin/mentor/deleteMentor`, formData, {
        headers: {
          "Content-Type": "multipart-formdata",
        },
      })
      .then((response) => {
        console.log(response.data);
    
        viewAllMentor();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    viewAllMentor();
  }, []);

  return (
    <AdminLayout>
      <div className="mentors-container">
        {/* Page Header */}
        <div className="page-header">
          <div className="page-header-top">
            <div>
              <h1 className="page-title">
                <span className="page-title-icon">👨‍🏫</span>
                Mentors Management
              </h1>
              <p className="page-description">Add, edit, and manage mentors</p>
            </div>
          </div>
        </div>

        {/* Add/Edit Form */}
        <div className="form-section">
          <h3 className="form-title">
            {editId ? "✏️ Edit Mentor" : "➕ Add New Mentor"}
          </h3>
          <Form.Group className="mb-3">
            <Form.Label>Name</Form.Label>
            <Form.Control
              type="text"
              name="name"
              placeholder="Enter mentor name"
              value={name}
              onChange={(event) => {
                setName(event.target.value);
              }}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Degree</Form.Label>
            <Form.Control
              type="text"
              name="degree"
              placeholder="e.g., PhD Computer Science"
              value={degree}
              onChange={(event) => {
                setDegree(event.target.value);
              }}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Specialization</Form.Label>
            <Form.Control
              type="text"
              name="specialization"
              placeholder="e.g., Artificial Intelligence"
              value={specialization}
              onChange={(event) => {
                setSpecialization(event.target.value);
              }}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Subject</Form.Label>
            <Form.Control
              type="text"
              name="subject"
              placeholder="e.g., Machine Learning"
              value={subject}
              onChange={(event) => {
                setSubject(event.target.value);
              }}
              required
            />
          </Form.Group>

          <div className="form-actions">
            <Button onClick={()=>{
              if(editId)
              {
                 updateMentor(); 
              }else{
                
                createMentor();
              }
            }} variant="primary" type="button">
              {editId ? "✓ Update Mentor" : "+ Add Mentor"}
            </Button>
            {editId && (
              <Button
                variant="secondary"
                onClick={() => {
                  setEditId(null);
                    setName("");
                    setDegree("");
                    setSpecialization("");
                    setSubject("");
                }}
              >
                Cancel
              </Button>
            )}
          </div>
        </div>

        {/* Table Section */}
        <div className="table-section">
          <h3 className="table-title">📋 All Mentors</h3>
          <div className="table-responsive">
            <Table bordered hover>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Degree</th>
                  <th>Specialization</th>
                  <th>Study Groups</th>
                  <th>Subject</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {mentors.map((mentor) => (
                  <tr key={mentor.id}>
                    <td>{mentor.id}</td>
                    <td>{mentor.name}</td>
                    <td>{mentor.degree}</td>
                    <td>{mentor.specialization}</td>
                    <td>{mentor.chstudygroups.map((group) => (
                      <span key={group.id} className="badge bg-primary text-white me-1">
                        {group.groupName}
                      </span>
                    ))}</td>
                    <td>{mentor.subject}</td>
                    <td>
                      <Badge
                        bg={mentor.status === "active" ? "success" : "danger"}
                      >
                        {mentor.status === "active" ? "Active" : "Inactive"}
                      </Badge>
                    </td>
                    <td>
                      <div className="action-buttons">
                        <Button
                          variant="warning"
                          size="sm"
                          onClick={() => {
                            setEditId(mentor.id);
                            setMentorId(mentor.id);
                            setName(mentor.name);
                            setDegree(mentor.degree);
                            setSpecialization(mentor.specialization);
                            setSubject(mentor.subject);
                          }}
                          title="Edit"
                        >
                          ✏️
                        </Button>
                        <Button
                          variant="danger"
                          size="sm"
                          onClick={() => {
                            deleteMentor(mentor.id)
                          }}
                          title="Delete"
                        >
                          🗑️
                        </Button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default Mentors;
